import { render, staticRenderFns } from "./p295_blog.vue?vue&type=template&id=70f7cea4"
import script from "./p295_blog.vue?vue&type=script&lang=js"
export * from "./p295_blog.vue?vue&type=script&lang=js"
import style0 from "./p295_blog.vue?vue&type=style&index=0&id=70f7cea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {P295BlogMain: require('/root/containers/hermes_eshop/components/hyper/p295/p295_blog_main.vue').default,P295BlogListing: require('/root/containers/hermes_eshop/components/hyper/p295/p295_blog_listing.vue').default})
